const LOGO_SRC =
  "https://www.voltagepictures.com/themes/theme-voltage/assets/img/voltage-logo.png";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="px-4 md:px-8 pt-14 md:pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:col-span-1">
            <img src={LOGO_SRC} alt="Voltage Pictures" className="h-9 w-auto object-contain brightness-0 invert" />
            <p className="mt-5 text-sm leading-relaxed text-background-200/80 max-w-xs">
              An independent production, sales and distribution company bringing bold,
              commercial films to audiences in more than 120 territories worldwide.
            </p>
            <div className="mt-6 flex items-center gap-2.5">
              {[
                { icon: "ri-facebook-fill", href: "https://www.facebook.com/voltagepics", label: "Facebook" },
                { icon: "ri-twitter-x-fill", href: "https://twitter.com/voltagepictures", label: "X" },
                { icon: "ri-youtube-fill", href: "https://www.youtube.com/user/VoltagePicturesLLC", label: "YouTube" },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={s.label}
                  className="flex items-center justify-center w-9 h-9 rounded-full bg-background-100/10 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-label text-xs tracking-[0.22em] uppercase text-accent-400">Navigate</h4>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                { label: "New Releases", href: "#new-releases" },
                { label: "Library", href: "#library" },
                { label: "About", href: "#about" },
                { label: "Press", href: "#press" },
                { label: "Contact", href: "#contact" },
              ].map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-background-200/80 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-xs tracking-[0.22em] uppercase text-accent-400">Sales & Acquisitions</h4>
            <ul className="mt-5 space-y-3 text-sm text-background-200/80">
              <li className="flex items-start gap-2.5">
                <i className="ri-mail-line mt-0.5 text-accent-400"></i>
                <a href="mailto:team@thevoltagepictures.com" className="hover:text-background-50 transition-colors cursor-pointer">
                  team@thevoltagepictures.com
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-phone-line mt-0.5 text-accent-400"></i>
                <a href="tel:+13234648351" className="hover:text-background-50 transition-colors cursor-pointer">
                  (323) 464-8351
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-map-pin-line mt-0.5 text-accent-400"></i>
                <span>
                  6360 Deep Dell Place
                  <br />
                  Los Angeles, CA 90068
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-label text-xs tracking-[0.22em] uppercase text-accent-400">Markets</h4>
            <ul className="mt-5 space-y-3 text-sm text-background-200/80">
              <li>American Film Market</li>
              <li>European Film Market</li>
              <li>Marché du Film — Cannes</li>
              <li>Toronto International Film Festival</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-100/15">
        <div className="px-4 md:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-200/70 text-center sm:text-left">
            © {year} Voltage Pictures, LLC · All rights reserved.
          </p>
          <div className="flex items-center gap-5 text-xs">
            <a href="#contact" className="text-background-200/70 hover:text-background-50 transition-colors cursor-pointer">
              Terms &amp; Conditions
            </a>
            <span className="text-background-100/25">|</span>
            <a href="#contact" className="text-background-200/70 hover:text-background-50 transition-colors cursor-pointer">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}